import { Asset } from "./assets"
import { PaginatedRecords } from "./common"
import { Cluster, Filter } from './clusterFilters';

export interface ErrorResponse {
  error: any
}
export interface FetchClusterRequest {
  id: string
}

export interface FetchClusterErrorResponse {
  id: string,
  error: any
}

export interface FetchClusterResponse {
  response: Cluster
}

export interface FetchAssetsRequest {
  requestBody: FilterBody,
  page: number,
  isForDownload: boolean
}

interface FilterBody {
  filters: Filter[],
  orderBy: string,
  query: string,
  sortBy: string
}

export interface FetchAssetsResponse {
  response: PaginatedRecords<Asset>
}


export interface CreateClusterRequest {
  requestBody: {
    filters: Filter[],
    filtersSet: boolean,
    name: string,
    nameSet: boolean
  }
}

export interface UpdateClusterRequest {
  id: string,
  requestBody: {
    filters: Filter[],
    filtersSet: boolean,
    name: string,
    nameSet: boolean
  }
}

export interface DeleteAssetsRequest {
  filters: Filter[]
}

export interface UpdateAssetsRequest {
  customFields: CustomFieldItem[],
  filters?: Filter[],
  permissions: {
    download: AssetAccess
    share: AssetAccess
  },
  tags: string[],
  expriyDate: string | null
}

export interface CustomFieldItem {
  id: string,
  name: string,
  value : CustomFieldValue[]
}

interface CustomFieldValue{
  id: string,
  value: string
}

export enum AssetAccess {
  none = "NONE",
  true = "TRUE",
  false = "FALSE"
}

export interface FetchAssetsForContentScoreRequest {
  category: string;
  value: string;
  page: number
}

export interface FetchAssetsForContentScoreResponse {
  response: PaginatedRecords<Asset>;
}

export interface FetchAssetsForContentScoreErrorResponse {
  error: any;
}

export interface FetchContentGraphValuesRequest {
  category: string;
  value: string;
}

export interface FetchContentGraphValuesResponse {
  response: any;
}

export interface FetchContentGraphValuesErrorResponse {
  error: any;
}

export interface FetchingContentScoreResponse {
  response: {
    averageContentScore: number;
    contentAgingCount: number;
    contentDuplicationCount: number;
    contentExpiryCount: number;
    unstructuredContentCount: number;
  };
}

export interface FetchingContentScoreErrorResponse {
  error: any;
}
